import { permissionGuard } from '../guards/permission.guard';

export const canCreateSettlementsGuard = permissionGuard(
  'Settlement', // NOTE: Assumes 'Settlement' is the resource name in your backend.
  ['create'],
  'You are not authorized to create or edit settlements.'
);

export const canUpdateSettlementGuard = permissionGuard(
  'Settlement',
  'update',
  'You are not authorized to update settlements.'
);
